// extracted by mini-css-extract-plugin
export default {"cls1":"VeloDialog-VeloDialogButton_cls1__9igpA","cls2":"VeloDialog-VeloDialogButton_cls2__pXkDO VeloDialog-VeloDialogButton_cls1__9igpA"};